import Vue from 'vue'
import Application from './App.vue'
import Vuex from 'vuex'
import store from './common/Store';
import router from './router';
Vue.use(Vuex);
Vue.prototype.$eventBus = new Vue()
window.axios = require('axios');

// Create a quiz object with a title and two questions.
// A question has one or more answer, and one or more is valid.
import quiz from "./appdata/quiz";
var App = Object.freeze({
  name: 'Owned',
  quiz: quiz,
});
import tooltip from "./components/common/Tooltip";
Vue.component("Tooltip", tooltip);
Vue.prototype.App = App;
new Vue({
  el: '#app',
  router,
  store,

  render: h => h(Application)
})

import Question from './components/steps/Question'



//router.replace('/')
